import { type DeliveryNoteOption, type DeliveryNoteSearchAsset } from './types';

/**
 * Maps a raw search asset to a picker option. The DLN number is read from the
 * asset state header, falling back to the asset id when it is absent.
 */
export const toDeliveryNoteOption = (
  asset: DeliveryNoteSearchAsset,
): DeliveryNoteOption => ({
  assetId: asset.id,
  dlnNumber: asset.assetState?.body?.header?.id ?? asset.id,
});
